export class LocationSearchModel {
    id?: number;
    providerId: number;

}
